export const krzysztofRosa = {
    'meta': {
        'title': 'Psychiatra Krzysztof Rosa • Centrum Psychiatrii COLLIGO',
        'description': 'Lekarz specjalista w dziedzinie psychiatrii. Studia ukończył na wydziale lekarskim Uniwersytetu Medycznego w Białymstoku.'
    },
    'url': {
        'address': '/torun/zespol/krzysztof-rosa/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/krzysztof-rosa.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psychiatra Krzysztof Rosa'
        }
    }
}